import { ActivityByDateApi } from './activity-by-date-api';

export class ActivityByServerApi
{
    details: ActivityByDateApi[];
    master: string;
    serverShort: string;
}
